import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {EstimateProductQty} from "../types/EstimateProductQty";
import {EstimateResult} from "../types/EstimateResult";

export const useEstimate = (dealerId: number, products: EstimateProductQty[], zipCode: string) => {
    const { data, isLoading, refetch } = useQuery({
        queryKey: ['ee-pro-estimate', dealerId, zipCode, JSON.stringify(products)],
        queryFn: async () => {
            if (products.length === 0) {
                return { products: [], subTotal: 0, total: 0, discount: 0, promoEnd: null } as EstimateResult;
            }
            let total = products.reduce((acc, item) => acc + item.quantity, 0);
            if (total === 0) {
                return { products: [], subTotal: 0, total: 0, discount: 0, promoEnd: null } as EstimateResult;
            }

            return await apiClient.post('ee-pro/estimate', {
                dealerID: dealerId,
                products: products,
                zipCode: zipCode
            }) as EstimateResult
        },
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || { products: [], subTotal: 0, total: 0, discount: 0, promoEnd: null } as EstimateResult,
        isLoading: isLoading,
        refetch: refetch
    };
};
